var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contractors-actions"},[_c('div',{staticClass:"search"},[_c('tol-type-ahead',{attrs:{"search-params":{
        url: '/contractors/list',
        searchKeys: ['searchParam'],
        urlParams: {
          recordsPerPage: _vm.contractorsPerPage,
          offset: _vm.contractorsListingOffset,
          sortBy: _vm.contractorsSortBy,
          sortDirection: _vm.contractorsSortDirection,
          activeInactive: _vm.contractorsActiveInactive
        }
      },"allow-empty-search":true,"results-in-dropdown":false},on:{"filtered":function($event){return _vm.onFiltered($event)}}})],1),_c('div',{staticClass:"right"},[_c('router-link',{attrs:{"to":"/contractors/create"}},[_c('TolAltButton',{attrs:{"icon-name":"plus","label":"New contractor"}})],1),_c('TolAltButton',{attrs:{"icon-name":"file-excel","label":"Export to Excel"},on:{"click":_vm.exportAsExcel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }